import { apiUc } from '../http';
import ServiceCRUD from './ServiceCRUDFLEXUC';

class AudioService extends ServiceCRUD {
  constructor() {
    super(`/api/audios`);
  }

  findAll = (showDisabled = false) => {
    return apiUc.get(`${this.path}?showDisabled=${showDisabled}`);
  };

  findById = (id) => {
    return apiUc.get(`${this.path}/${id}`);
  };
}

export default new AudioService();
